import styled from "../../styled-components.mjs";
export var TableElement = styled.table.withConfig({
  displayName: "Table__TableElement",
  componentId: "sc-evwssh-0"
})(["max-inline-size:100%;inline-size:100%;text-align:start;border-collapse:collapse;overflow-wrap:break-word;"]);